// Everything that "enters" waits for the splash to open its N (index.html dispatches `ns:reveal`).
// Without a splash on this load the hero is already revealed, so `fn` runs immediately.
// Returns an unsubscribe function for effect cleanup.
export function onReveal(fn: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  if (window.__nsRevealed || !document.getElementById("nsSplash")) {
    fn();
    return () => {};
  }
  window.addEventListener("ns:reveal", fn, { once: true });
  return () => window.removeEventListener("ns:reveal", fn);
}
